<template>
  <div>
    <yo :cta="'Yo!'" :ownerID="$route.params.ownerID" :earthID="$route.params.earthID" :styler="{ fontSize: '15px', width: '60px', lineHeight: '60px', height: '60px',  borderRadius: '60px', position: 'absolute', bottom: '-15px', right: '-20px' }"></yo>
  </div>
</template>

<script>
export default {
  components: {
    yo: require('../widget/yo.vue').default
  }
}
</script>

<style>
.columnfun{
  width: calc(100% - 30px);
  max-width: 1200px;
  margin: 0px auto;
}
</style>
